import React from 'react';
import AlbumList from './albums/AlbumList';
import {Link} from 'react-router-dom';
import './Products.css';

function Store() {
  return (
    <div className="main store">
      <div className="store__container">
        <Link to="/product/60c62be26ebe76d9d4402fec">
          <img
            src="https://justvideolife.com/wp-content/uploads/2019/09/new-video-bruce-melodie-katerina.jpg"
            style={{width: '100%'}}
            alt="Katerina"
          />
        </Link>
        <AlbumList />
      </div>
    </div>
  );
}

export default Store;
